/*
* 侧边栏伸缩动画组件
*/
<template>
  <div styleName="sideMove" :style="wrapperStyle" ref="wrapper">
    <slot></slot>
    <div styleName="sideWrapper" :style="asideStyle" ref="aside" :data-dir="direction">
      <slot name="aside"></slot>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
const INTERVAL = 18
export default {
  name: 'sideMove',
  mixins: [CSSModules(styles)],
  data () {
    return {
      initOpenStatus: this.openStatus
    }
  },
  props: {
    direction: {
      default: 'H',
      validator (v) {
        return ~['H', 'V'].indexOf(v)
      }
    },
    asideWidth: {
      default: 320
    },
    minimum: {
      default: 0
    },
    openStatus: {
      type: Boolean
    }
  },
  computed: {
    wrapperStyle () {
      return this.direction === 'H'
        ? {
          'padding-right': `${this.initOpenStatus ? this.asideWidth : this.minimum}px`,
        } : {
          'padding-top': `${this.initOpenStatus ? this.asideWidth : this.minimum}px`
        }
    },
    asideStyle () {
      return this.direction === 'H'
        ? {
          width: `${this.initOpenStatus ? this.asideWidth : this.minimum}px`
        } : {
          height: `${this.initOpenStatus ? this.asideWidth : this.minimum}px`
        }
    },
    matchingPadding () {
      return this.direction === 'H' ? 'padding-right' : 'padding-top'
    },
    matchingDiret () {
      return this.direction === 'H' ? 'right' : 'top'
    }
  },
  watch: {
    openStatus (v) {
      if (v) {
        this._show()
      } else {
        this._hide()
      }
    }
  },
  methods: {
    _hide () {
      window.requestAnimationFrame(this._stepHide)
    },
    _show () {
      window.requestAnimationFrame(this._stepShow)
    },
    _stepHide () {
      let currentWrapperPadding = parseInt(this.$refs.wrapper.style[this.matchingPadding])
      let asidePadding = parseInt(this.$refs.aside.style[this.matchingDiret]) || 0
      console.log(currentWrapperPadding, asidePadding)
      if (currentWrapperPadding - this.minimum > INTERVAL) {
        this.$refs.wrapper.style[this.matchingPadding] = `${currentWrapperPadding - INTERVAL}px`
        this.$refs.aside.style[this.matchingDiret] = `${asidePadding - INTERVAL}px`
        window.requestAnimationFrame(this._stepHide)
      } else {
        console.log(this.asideWidth, this.minimum)
        this.$refs.wrapper.style[this.matchingPadding] = `${this.minimum}px`
        this.$refs.aside.style[this.matchingDiret] = `${-this.asideWidth + this.minimum}px`
      }
    },
    _stepShow () {
      let currentWrapperPadding = parseInt(this.$refs.wrapper.style[this.matchingPadding])
      let asidePadding = parseInt(this.$refs.aside.style[this.matchingDiret])
      console.log(this.asideWidth, currentWrapperPadding)
      if (this.asideWidth - currentWrapperPadding > INTERVAL) {
        this.$refs.wrapper.style[this.matchingPadding] = `${currentWrapperPadding + INTERVAL}px`
        this.$refs.aside.style[this.matchingDiret] = `${asidePadding + INTERVAL}px`
        window.requestAnimationFrame(this._stepShow)
      } else {
        this.$refs.wrapper.style[this.matchingPadding] = `${this.asideWidth}px`
        this.$refs.aside.style[this.matchingDiret] = `0px`
      }
    }
  }
}
</script>
